import {Divider, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Typography} from '@material-ui/core';
import {Tools} from 'BOSTools/models/Tools';
import {BOSToolsRouteConstants} from 'BOSTools/Routes';
import React, {useState} from 'react';
import {useHistory} from 'react-router-dom';
import './BOSTools.sass';

const BOSTools = () => {
  const history = useHistory();
  const [currentTool, setCurrentTool] = useState(Tools[0]);

  const GrandfatheringData = 'Grandfathering Data Report';

  const handleOnChange = (e: React.ChangeEvent<{name?: string | undefined; value: unknown}>) => {
    e.target.value === GrandfatheringData
      ? history.push(BOSToolsRouteConstants.GRANDFATHERING_DATA)
      : setCurrentTool(Tools.find(t => t.name === e.target.value)!);
  };

  return (
    <Grid className="bostools_form" container alignItems="center" direction="column">
      <Paper className="bostools_form__paper">
        <Typography variant="h6" className="bostools_form__title">
          BOS Tools
        </Typography>
        <FormControl variant="outlined" fullWidth>
          <InputLabel>Tools</InputLabel>
          <Select labelWidth={50} onChange={handleOnChange} value={currentTool.name || ''}>
            {Tools.map(tool => (
              <MenuItem key={`BOSTools-${tool.name}`} value={tool.name}>
                {tool.name}
              </MenuItem>
            ))}
            {/* This is treated differently due to it is a table view */}
            <MenuItem key="BOSTools-Grandfathering Data Report" value={GrandfatheringData}>
              Grandfathering Data Report
            </MenuItem>
          </Select>
        </FormControl>
        <Divider className="bostools_form__divider" />
        {/* Render the current tool sub component dynamically */}
        <currentTool.component />
      </Paper>
    </Grid>
  );
};

export default BOSTools;
